import { useState } from 'react';

import style from './SelectButtonList.module.scss';

import { SelectButtonItem } from '../SelectButtonItem';
import { ClickOutsideMask } from '../ClickOutsideMask';
import { Icon, IconType } from '@components/Icon';
import classnames from 'classnames';

export interface SelectButtonListProps {
    disabled?: boolean;
    isOpen?: boolean;
    primaryActionDisabled?: boolean;
    dataTest?: string;
    items: SelectButtonMenuItem[];
    ignoreZeroItemsStyle?: boolean;
    modifiers?: SelectButtonListModifiers[];
    theme?: SelectButtonTheme;
    onOpenerClick?(): void;
    onButtonClick?(): void;
}

export interface SelectButtonMenuItem {
    label: string;
    disable?: boolean;
    dataTest: string;
    isHighlighted?: boolean;
    onClick(): void;
}

export enum SelectButtonListModifiers {
    // @ts-ignore
    Single = style.single,
    // @ts-ignore
    Header = style.header,
    // @ts-ignore
    Pair = style.pair,
}

export enum SelectButtonTheme {
    // @ts-ignore
    White = style.white,
}

export function SelectButtonList({
    items = [],
    isOpen,
    disabled,
    onOpenerClick,
    modifiers,
    ignoreZeroItemsStyle,
    dataTest,
    theme,
}: SelectButtonListProps) {
    const [isOpenInternal, setIsOpenInternal] = useState(false);

    const resolvedIsOpen = isOpen ?? isOpenInternal;
    const handleOpenerClick = onOpenerClick ?? toggleIsOpen;

    function toggleIsOpen() {
        setIsOpenInternal(prev => !prev);
    }

    return (
        <div
            className={classnames([
                style.root,
                resolvedIsOpen && style.open,
                !items.length && !ignoreZeroItemsStyle && style.withoutItems,
                disabled && style.root_disable,
                modifiers && [...modifiers],
                !!theme && theme,
            ])}
            data-test={dataTest}
            data-testid={dataTest}
            onClick={disabled ? undefined : handleOpenerClick}
        >
            <div className={classnames([style.opener])}>
                <div className={style.openerIcon}>
                    <Icon type={IconType.ARROW_DOWN_REDESIGN} />
                </div>
            </div>
            {resolvedIsOpen && !ignoreZeroItemsStyle && (
                <ClickOutsideMask
                    transparentBackground
                    onClickOutside={handleOpenerClick}
                />
            )}
            <div className={style.menuWrapper}>
                {items.map(item => (
                    <SelectButtonItem
                        key={item.label}
                        label={item.label}
                        disable={item.disable}
                        dataTest={item.dataTest}
                        isHighlighted={item.isHighlighted}
                        toggleIsOpen={handleOpenerClick}
                        onItemClick={item.onClick}
                    />
                ))}
            </div>
        </div>
    );
}
